<template>
  <div class="join">
    <div v-if="inviteStatus === 'in-progress'">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-if="inviteStatus === 'good_invite'">
      <p>You've been invited to join the <strong>{{ inviteOrg.name }}</strong> organization.</p>
      <LoginForm
        v-if="!loggedIn"
        :loginErr="loginErr"
        :loginErrMessage="loginErrMessage"
        :joinOrg=true
      />
      <v-btn
        class="join-button"
        v-if="loggedIn"
        @click="acceptInvite({ code: inviteCode })"

      >
        Join {{ inviteOrg.name }}
      </v-btn>
    </div>
    <div v-if="inviteStatus === 'accepting_invite'">
      Accepting...
    </div>
    <div v-if="inviteStatus === 'bad_invite'">
      Uh oh, something went wrong: {{ inviteError }}
    </div>
  </div>
</template>

<script>
import logger from '@/logger';
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import LoginForm from 'shared/components/LoginForm.vue';

export default {
  name: 'Invite',
  components: {
    LoginForm,
  },
  async mounted() {
    if (this.inviteCode) {
      await this.$store.dispatch('Invite/checkInvitation', { code: this.inviteCode });
      this.checkIfAlreadyMember();
    } else {
      logger.log('routing to /login from JoinOrg');
      this.$router.push('/login');
    }
  },
  computed: {
    ...mapState({
      inviteStatus: state => state.Invite.status,
      inviteOrg: state => state.Invite.org,
      inviteError: state => state.Invite.error,
      acceptError: state => state.Invite.acceptError,
      orgs: state => state.orgs.data,
      loginErr: state => state.users.loginErr,
      loginErrMessage: state => state.users.loginErrMessage,
    }),
    ...mapGetters({
      loggedIn: 'users/loggedIn',
    }),
    inviteCode() {
      return _.get(this, '$router.currentRoute.query.code');
    },
  },
  methods: {
    ...mapActions({
      acceptInvite: 'Invite/acceptInvitation',
    }),
    async loginOrRegister(payload) {
      await this.$store.dispatch('Invite/loginOrRegister', { ...payload, code: this.inviteCode });
      this.$store.dispatch('Notifications/flashMessage', {
        msg: `Welcome to ${this.inviteOrg.name}!`,
        msgType: 'success',
      });
      this.$router.push('/');
    },
    checkIfAlreadyMember() {
      if (!this.loggedIn) return;
      if (this.inviteOrg && this.orgs && _.map(this.orgs, 'id').includes(this.inviteOrg.id)) {
        this.$store.dispatch('Notifications/flashMessage', {
          msg: `You're already a member of ${this.inviteOrg.name}`,
        });
        this.$router.push('/');
      }
    },
  },
};
</script>

<style lang="scss">
.join {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.login {
  text-align: center;
}
main {
  padding-top: 50px;
  .login-form {
    padding: 0px 40px;
    width: 33%;
    min-width: 450px;
    margin-bottom: 20px;
  }
  .logo {
    margin-bottom: 40px;
    padding: 0px 10px 0px;
    max-width: 100%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .submit-button, .join-button {
    background-color: rgb(23, 198, 140);
    color: white;
    &:disabled {
      background-color: gainsboro !important;
    }
  }
  .title {
    text-align: center;
  }
  .error {
    color: red;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JoinOrg.vue